import { BusStopHeader } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopHeader";
import {
  BusStopGrid,
  BusStopGridBody,
} from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopGrid";
import { BusStopTableBody } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopTableBody";
import { useTranslation } from "react-i18next";
import { AlternativeTransportVehicle } from "shared/types/alternativeTransport";

interface IncidentsAndStopsPanelsProps {
  vehicle: AlternativeTransportVehicle;
}

export const IncidentsAndStopsPanels = ({
  vehicle,
}: IncidentsAndStopsPanelsProps) => {
  const { t } = useTranslation();

  return (
    <BusStopGrid aria-label={t("Holdeplass")} role="table">
      <div role="rowgroup">
        <BusStopHeader />
      </div>
      <BusStopGridBody role="rowgroup">
        <BusStopTableBody
          itinerary={vehicle.itinerary}
          vehicleStatus={vehicle.vehicleStatus}
        />
      </BusStopGridBody>
    </BusStopGrid>
  );
};
